<template>
  <!-- start preloader -->
  <!-- <div class="preloader" id="preloader"></div> -->
  <!-- end preloader -->

  <!-- Scroll To Top Start-->
  <a href="javascript:void(0)" class="scrollToTop"
    ><i class="fas fa-angle-double-up"
  /></a>
  <!-- Scroll To Top End -->

  <!-- Banner Section start -->
  <section class="banner-section overflow-visible">
    <div class="overlay">
      <div class="banner-content tw-relative">
        <img
          src="../assets/images/carousel_img.jpg"
          alt=""
          class="tw-w-full tw-object-cover md:tw-block tw-hidden" />
        <div
          class="md:tw-absolute md:tw-top-[40%] md:tw-left-[13%] tw-flex tw-items-center tw-justify-center">
          <div
            class="tw-rounded-lg tw-p-4 md:tw-bg-transparent md:tw-p-0 tw-w-full md:tw-w-auto tw-max-w-md md:tw-max-w-none">
            <h2
              class="tw-text-xl lg:tw-text-3xl xl:tw-text-4xl tw-text-black tw-text-left tw-font-light">
              Welcome Casino Package
            </h2>
            <p
              class="tw-text-2xl md:tw-text-[3rem] xl:tw-text-[4.5rem] tw-leading-none tw-w-full md:tw-w-[60%] tw-text-[#ed115f] tw-mt-2 md:tw-mt-4 tw-font-semibold">
              UP TO 1000£ + 300 FREE SPINS
            </p>
            <button
              class="btn-signup-car tw-mt-4 md:tw-mt-8 tw-mb-2 md:tw-mb-6"
              @click="openPopup('register')">
              {{ $t('register') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- <HomeSportGames /> -->

  <!-- <HeaderTabs /> -->

  <!-- Popular Game start -->
  <HomePopularGames :games="allGames" />
  <!-- Popular Game end -->

  <!-- What Player Says Start -->
  <section>
    <h2
      class="tw-text-center tw-text-xl tw-font-semibold tw-pb-12 tw-mt-14 tw-text-[#ed115f]">
      {{ $t('homePage.whatPlayerSays') }}
    </h2>

    <div class="container tw-mb-16">
      <div class="tw-grid tw-grid-cols-12 tw-gap-6">
        <div
          class="md:tw-col-span-6 tw-col-span-12 tw-bg-white tw-shadow-lg tw-p-6 tw-rounded-md">
          <div class="tw-flex tw-items-start">
            <div class="tw-mr-4 tw-flex-shrink-0">
              <img
                src="../assets/images/user.png"
                class="tw-w-full"
                alt="Image 1" />
            </div>
            <div class="tw-flex-1">
              <p class="tw-font-normal tw-text-black">FAHAD FOIZ</p>
              <p
                class="md:tw-text-[15px] tw-text-sm tw-leading-6 tw-pt-2 tw-text-gray-500">
                {{ $t('homePage.testimonial1') }}
              </p>
            </div>
          </div>
        </div>

        <div
          class="md:tw-col-span-6 tw-col-span-12 tw-bg-white tw-shadow-lg tw-p-6 tw-rounded-md">
          <div class="tw-flex tw-items-start">
            <div class="tw-mr-4 tw-flex-shrink-0">
              <img
                src="../assets/images/user.png"
                class="tw-w-full"
                alt="Image 1" />
            </div>
            <div class="tw-flex-1">
              <p class="tw-font-normal tw-text-black">Stan Lazi</p>
              <p
                class="md:tw-text-[15px] tw-text-sm tw-leading-6 tw-pt-2 tw-text-gray-500">
                {{ $t('homePage.testimonial2') }}
              </p>
            </div>
          </div>
        </div>

        <div
          class="md:tw-col-span-6 tw-col-span-12 tw-bg-white tw-shadow-lg tw-p-6 tw-rounded-md">
          <div class="tw-flex tw-items-start">
            <div class="tw-mr-4 tw-flex-shrink-0">
              <img
                src="../assets/images/user.png"
                class="tw-w-full"
                alt="Image 1" />
            </div>
            <div class="tw-flex-1">
              <p class="tw-font-normal tw-text-black">Uahad Foiza</p>
              <p
                class="md:tw-text-[15px] tw-text-sm tw-leading-6 tw-pt-2 tw-text-gray-500">
                {{ $t('homePage.testimonial3') }}
              </p>
            </div>
          </div>
        </div>

        <div
          class="md:tw-col-span-6 tw-col-span-12 tw-bg-white tw-shadow-lg tw-p-6 tw-rounded-md">
          <div class="tw-flex tw-items-start">
            <div class="tw-mr-4 tw-flex-shrink-0">
              <img
                src="../assets/images/user.png"
                class="tw-w-full"
                alt="Image 1" />
            </div>
            <div class="tw-flex-1">
              <p class="tw-font-normal tw-text-black">John Doe</p>
              <p
                class="md:tw-text-[15px] tw-text-sm tw-leading-6 tw-pt-2 tw-text-gray-500">
                {{ $t('homePage.testimonial4') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section>
    <h2
      class="tw-text-center tw-text-xl tw-font-semibold tw-pb-8 tw-mt-6 tw-text-[#ed115f]">
      {{ $t('homePage.howToStart') }}
    </h2>

    <div class="container tw-mb-10">
      <div class="tw-grid tw-grid-cols-12 tw-gap-6">
        <div class="md:tw-col-span-4 tw-col-span-12">
          <div class="tw-flex tw-items-start">
            <div class="tw-flex-1 text-center">
              <p class="tw-font-semibold tw-text-black">{{ $t('homePage.loginOrSignup') }}</p>
              <p class="md:tw-text-[15px] tw-text-sm tw-leading-6 tw-pt-2 tw-text-gray-500">
                {{ $t('homePage.loginOrSignupDesc') }}
              </p>
            </div>
          </div>
        </div>
        <div class="md:tw-col-span-4 tw-col-span-12">
          <div class="tw-flex tw-items-start">
            <div class="tw-flex-1 text-center">
              <p class="tw-font-semibold tw-text-black">{{ $t('homePage.depositCash') }}</p>
              <p class="md:tw-text-[15px] tw-text-sm tw-leading-6 tw-pt-2 tw-text-gray-500">
                {{ $t('homePage.depositCashDesc') }}
              </p>
            </div>
          </div>
        </div>
        <div class="md:tw-col-span-4 tw-col-span-12">
          <div class="tw-flex tw-items-start">
            <div class="tw-flex-1 text-center">
              <p class="tw-font-semibold tw-text-black">{{ $t('homePage.playEnjoy') }}</p>
              <p class="md:tw-text-[15px] tw-text-sm tw-leading-6 tw-pt-2 tw-text-gray-500">
                {{ $t('homePage.playEnjoyDesc') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="tw-w-full tw-flex tw-justify-center">
        <button class="btn-signup-car tw-mt-12" @click="openPopup('login')">
          {{ $t('signIn') }}
        </button>
      </div>
    </div>
  </section>

  <!-- How to Start -->

  <!-- How to End -->

  <!-- <div class="!tw-bg-[#030313]">
    <HomeProviders />
  </div> -->
</template>

<script>
import Const from '@/const'
import HomeProviders from '@/components/HomeProviders.vue'
import HomeSportGames from '@/components/HomeSportGames.vue'
// import HomeGameProviders from '@/components/HomeGameProviders.vue';
import HomePopularGames from '@/components/HomePopularGames.vue'
// import HeaderTabs from '@/components/HeaderTabs.vue'
//import HomeJackpotGames from '@/components/HomeJackpotGames.vue';
import { allGames } from '@/sampleData'
import { usePopupStore } from '../stores/popup'
import { useAuthStore } from '../stores/authStore'
import { useRouter } from 'vue-router'
import { Carousel, Slide } from 'vue3-carousel'
import { computed, onBeforeUnmount, onMounted, reactive } from 'vue'

export default {
  name: 'HomePage',
  components: {
    // HomeProviders,
    // Carousel,
    // Slide,
    // HeaderTabs,
    // HomeSportGames,
    // HomeGameProviders
    HomePopularGames,
    //HomeJackpotGames
  },
  setup() {
    const config = reactive({
      itemsToShow: 1,
      autoplay: 4000,
      gap: 0,
      wrapAround: true,
      transition: 500,
    })
    return {
      config,
    }
  },
  data() {
    return {
      serverData: null,
      allGames: allGames,
      welcomeBonusShowed: false,
      router: null, // add router to data
    }
  },
  computed: {
    // Access the isAuthenticated property from Pinia store
    isAuthenticated() {
      const authStore = useAuthStore()
      return authStore.isAuthenticated
    },
  },
  unmounted() {
    window.removeEventListener('scroll', this.actionScroll)
  },
  created() {
    this.router = useRouter() // initialize router
    window.addEventListener('scroll', this.actionScroll)
  },
  mounted() {
    //this.fetchHomeCasino(); // Fetch data when the component is mounted
  },
  methods: {
    openPopup(popup) {
      const popupStore = usePopupStore()
      popupStore.showPopup(popup)
    },
    goToCasinoAll() {
      if (this.router) {
        this.router.push('/casino/all')
      }
    },
    actionScroll() {
      const scroll = window.scrollY
      if (scroll == 0 && this.welcomeBonusShowed == false) {
        // this.openPopup('welcome-bonus');
        // this.welcomeBonusShowed = true;
      }
    },
    async fetchHomeCasino() {
      const url = Const.URL

      const headers = {
        Accept: 'application/json, text/plain, */*',
        'Accept-Language': 'en-US,en;q=0.9,uk-UA;q=0.8,uk;q=0.7,pl;q=0.6',
        'Cache-Control': 'no-cache',
        Connection: 'keep-alive',
        'Content-Type': 'application/json',
        Cookie:
          'remember_web_59ba36addc2b2f9401580f014c7f58ea4e30989d=eyJpdiI6ImpnUDhDZWNhZmlwUnhJczdCdjY3cEE9PSIsInZhbHVlIjoiTXNqeWFqVm1UeXJjSEFMMm5wS3liajlWL2Z6QWQvZklBQldlNytpbGJWUmorSDhZWU1ZL21qRURCVUR3UW8yVTN5V0lFczB4cS90MVpYcDF6N2VRZjh0N1c2aitLb1FGSW1Xd3FpYzFTSkVqTUtuSVkvL04xMDR4NW9MRUtFM1d2SXc3T0lRMldLSndRQjVMSTlkcGxoTEpQM1NvUEFmRDZkcFV2RXE4d2Q5a3N0VUpMM09zOTY2dHIxZzVxWnM4Q3M5clFmTU1YLzZUM3pOU2xzY0plS1VMODNTN3Q3Ym9RbC90MnVlNHRzRT0iLCJtYWMiOiI4MjA5OGQxOWUzZGZlZGJkMzY3MGE4MmI4OTA2YzU5ZmQyZDllMzc1ZTgxYzUxMzA5NzgyOTgzNzcyM2M0ZGIzIn0%3D; XSRF-TOKEN=eyJpdiI6Ijl6a1pndjl5cVpucG1lSWluTFNUZFE9PSIsInZhbHVlIjoiRUJobyt3aENlUFEvczJ1SXJNWDRIbEx6RmdnYi8rUkpZM0lKRG1lMUdGeXEzSFRiYlhhK091cDJnc2pYZXI1K2pHY1l3Sm94YkR1eDVibGZ0TUFXM0hzKzlJR1lUTVdoNzhxT2NHMXpueGFQNVh6VEY2dkNWaTVDcHBCb1lwemciLCJtYWMiOiIwYjQ3ZmU2NGU2ZjFlZDY1NDIwMGQyYzFlMDdlYWFkM2YzN2QzNmNmNjA1MmYxNWMyYmVkOWMzNzU3ZDk4YjU5In0%3D; laravel_session=eyJpdiI6InN0UHFVTExkLzdwaU01cTNLVENldkE9PSIsInZhbHVlIjoiWDlsRk5nUnVWdTMzU1lKclllbG1KYXkxdkpHbEU5cXNPcGlBVks3ZGpBdmpRbFBiYVRhRWJRVC9RMjZ0N2xndTdlZndaZnRDdHNsOVBHWmVOUFgyallMWkNNQ0ZNNThHdldaTjliNUhhWWFxdUNWU0ZxVG84V3g1OWkrTWZ5c3IiLCJtYWMiOiIyYzk3ZWFiOWFiMzk4YjBiNmRkZWM4MGEzMmFhMzc5NTBjMjhjYTA3ZTE4YzAxMWE4YzRhYjRjNzVlMjY5YjJhIn0%3D',
        DNT: '1',
        Origin: 'https://arabianbet.net',
        Pragma: 'no-cache',
        Referer: 'https://arabianbet.net/home',
        'Sec-Fetch-Dest': 'empty',
        'Sec-Fetch-Mode': 'cors',
        'Sec-Fetch-Site': 'same-origin',
        'User-Agent':
          'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/131.0.0.0 Safari/537.36',
        'X-XSRF-TOKEN':
          'eyJpdiI6Ijl6a1pndjl5cVpucG1lSWluTFNUZFE9PSIsInZhbHVlIjoiRUJobyt3aENlUFEvczJ1SXJNWDRIbEx6RmdnYi8rUkpZM0lKRG1lMUdGeXEzSFRiYlhhK091cDJnc2pYZXI1K2pHY1l3Sm94YkR1eDVibGZ0TUFXM0hzKzlJR1lUTVdoNzhxT2NHMXpueGFQNVh6VEY2dkNWaTVDcHBCb1lwemciLCJtYWMiOiIwYjQ3ZmU2NGU2ZjFlZDY1NDIwMGQyYzFlMDdlYWFkM2YzN2QzNmNmNjA1MmYxNWMyYmVkOWMzNzU3ZDk4YjU5In0=',
        'sec-ch-ua':
          '"Google Chrome";v="131", "Chromium";v="131", "Not_A Brand";v="24"',
        'sec-ch-ua-mobile': '?0',
        'sec-ch-ua-platform': '"macOS"',
        timeout: '10000',
      }

      const body = {}

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()
        this.serverData = data // Update the component's state with the fetched data
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
  },
}
</script>

<style scoped>
.home {
  text-align: center;
  padding: 20px;
}

.banner-image-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  min-height: 400px;
  /* Adjust as needed for your design */
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-image-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.banner-item .main-content {
  text-align: left;
}

.btn-signup-car {
  font-size: 16px;
  background-color: #ed115f;
  color: #ffffff;
  padding: 10px 30px;
  border-radius: 22px;
  text-transform: uppercase;
  font-weight: 500;
}

.btn-signup-car:hover {
  background-color: #ca1051;
}

.btn-regis-car {
  font-size: 16px;
  background-color: transparent;
  color: #ed115f;
  border: 1px solid #ed115f;
  padding: 10px 35px !important;
  border-radius: 5px;
}

.btn-play-car {
  font-size: 16px;
  background-color: transparent;
  color: #ed115f;
  border: 1px solid #ed115f;
  padding: 6px 3rem;
  border-radius: 28px;
}

[lang='ar'] h2,
[lang='ar'] h3,
[lang='ar'] button,
[lang='ar'] p,
[lang='ar'] span,
[lang='ar'] li {
  font-family: 'Tajawal', sans-serif !important;
}
</style>
